export const imageAlts = {
  rooftop: {
    main: "Espace de coworking avec vue panoramique sur Paris depuis le 9ème arrondissement",
    secondary:
      "Bureaux privés et espaces partagés avec vue sur les toits de Paris",
    terrace:
      "Terrasse aménagée de l'espace de coworking avec vue sur le Sacré-Cœur",
    workspace:
      "Plateau privatisé pour entreprises au cœur du 9ème arrondissement de Paris",
  },
  location: {
    metro: "Espace de coworking à 50m du métro Cadet - Paris 9",
    gares:
      "Espace de travail proche des gares : Saint-Lazare, Gare du Nord, Gare de l'Est",
    neighborhood: "Coworking idéalement situé entre les gares parisiennes",
  },
  workspace: {
    private: "Bureaux privés et fermés pour équipes à Paris 9",
    shared: "Espace de coworking partagé lumineux avec vue dégagée",
    meeting: "Salles de réunion équipées dans le 9ème arrondissement",
    floor: "Plateau entier privatisable pour entreprises à Paris",
  },
  offers: {
    sharedOpenSpace: {
      main: "Open Space partagé lumineux au cœur de Paris 9ème",
      details: "Espace de coworking partagé avec 22 postes fixes",
      amenities: "Espace collaboratif avec accès aux salles de réunion",
      environment: "Environnement de travail dynamique et convivial",
    },
    privateOpenSpace: {
      main: "Open Space privatif pour entreprises à Paris",
      details: "Espace privatif de 70-75m² avec 20 postes",
      amenities: "Open space privé avec espace de confidentialité",
      environment: "Espace de travail collaboratif et confidentiel",
    },
    privateOffices: {
      main: "Bureaux fermés avec vue sur Paris",
      details: "Bureaux privatifs de 3 à 10 postes",
      amenities: "Bureaux avec terrasse privative",
      environment: "Espaces de travail calmes et lumineux",
    },
    entireFloor: {
      main: "Plateau entier privatisable à Paris 9",
      details: "Plateau de 110-120m² avec mix de bureaux",
      amenities: "Combinaison de bureaux fermés et open space",
      environment: "Solution complète pour entreprises en croissance",
    },
  },
  services: {
    meetingRooms: {
      main: "Salles de réunion équipées dans le 9ème arrondissement",
      phoneBox: "Phone box pour appels confidentiels",
      largeRoom: "Grande salle de réunion lumineuse",
    },
    cafeteria: {
      main: "Cafétéria avec vue sur patio intérieur",
      terrace: "Espace détente avec terrasse aménagée",
      kitchen: "Cuisine équipée pour les coworkers",
    },
    greenSpaces: {
      patio: "Patio arboré de 70m² au rez-de-chaussée",
      terrace: "Terrasse végétalisée de 90m² au 2ème étage",
      rooftop: "Rooftop avec vue panoramique sur Paris",
    },
    amenities: {
      common: "Espaces communs modernes et confortables",
      recreation: "Espace détente avec babyfoot",
      facilities: "Installations modernes et écologiques",
    },
  },
  place: {
    exterior: "Façade moderne du coworking Espace Cadet Paris 9",
    interior: "Espaces de travail design et lumineux",
    common: "Zones communes conviviales et fonctionnelles",
    views: "Vues exceptionnelles sur les toits de Paris",
  },
};
